// BSL-DYT §5 — Diyetisyen turları. Ekran başına en çok 3 balon, metin ≤ 140 karakter.
// Bir `data-tur` elemanı silinir/taşınırsa bu dosya aynı commit'te düzeltilir (çatı §12).
// hedef dizi olabilir: sırayla ilk görünen seçilir (Yeni Danışan penceresi açıksa pencere, değilse ray düğmesi).
const DANISAN_SEC = { hedef: '[data-tur="danisan-sec"]', metin: "Önce bir danışan seçin." };

export default {
  dytPaket: {
    yol: "/urun/yeniurun",
    oncelik: true,
    adimlar: [
      { hedef: '[data-tur="urun-paket-gun-diyet"]', metin: "Paket kaç gün geçerli. Danışanın plan uzunluğu buradan gelir; en az 7, en fazla 70 gün." },
    ],
  },
  dytDanisan: {
    yol: "/diyetisyen/calisma",
    adimlar: [
      {
        hedef: ['.p-dialog [data-tur="danisan-pencere"]', '[data-tur="danisan-yeni"]', '[data-tur="danisan-ray-ac"]'],
        metin: "Yeni danışan eklemek, ona bir diyet paketi satmak demektir.",
        kavram: "danisan",
      },
      // BSL-D2 (B-10): bekle — hedef 1. balonun açtığı Yeni Danışan penceresinde; başlangıçta görünmese de kalır.
      { hedef: '[data-tur="danisan-paket"]', bekle: true, metin: "Paketi seçin; danışanın plan süresi paket süresinden gelir." },
      { hedef: '[data-tur="danisan-kaydet"]', bekle: true, metin: "E-posta zorunlu; plan ve fiş bu adrese gider. Kaydedince müşteri, satış ve fiş birlikte açılır." },
    ],
  },
  // DYT-PLAN: çalışma alanı planı olmayan danışanda sihirbazı açar (bsl.pencereIstegi = "dytPlan");
  // planı varsa sihirbaz adımları görünmez, plan ekranı adımları kalır.
  dytPlan: {
    yol: "/diyetisyen/calisma",
    pencere: true,
    adimlar: [
      DANISAN_SEC,
      { hedef: '[data-tur="plan-baslangic"]', metin: "Sıfırdan başlayın ya da kayıtlı bir şablondan.", kavram: "sablon" },
      { hedef: '[data-tur="plan-sure"]', metin: "Plan kaç gün sürecek. En fazla 70 gün.", kavram: "tekPlan" },
      { hedef: '[data-tur="plan-ogun"]', metin: "Her gün öğünlerden oluşur. Öğün tiplerini Kütüphane'den değiştirebilirsiniz." },
      { hedef: '[data-tur="plan-besin-ekle"]', metin: "Öğüne besini doğrudan ekleyin ya da hazırladığınız bir yemeği seçin.", kavram: "besinYemek" },
      { hedef: '[data-tur="plan-gun-kopyala"]', metin: "Hazır bir günü diğer günlere kopyalayın; planı şablon olarak da kaydedebilirsiniz." },
    ],
  },
  // ? menüsü: plan ekranı görünüyorsa bu tur seçilir.
  dytPlanEkran: {
    yol: "/diyetisyen/calisma",
    oncelik: true,
    adimlar: [
      { hedef: '[data-tur="plan-ogun"]', metin: "Her gün öğünlerden oluşur. Öğün tiplerini Kütüphane'den değiştirebilirsiniz." },
      { hedef: '[data-tur="plan-besin-ekle"]', metin: "Öğüne besini doğrudan ekleyin ya da hazırladığınız bir yemeği seçin.", kavram: "besinYemek" },
      { hedef: '[data-tur="plan-gun-kopyala"]', metin: "Hazır bir günü diğer günlere kopyalayın; planı şablon olarak da kaydedebilirsiniz." },
    ],
  },
  dytOlcum: {
    yol: "/diyetisyen/calisma",
    pencere: true,
    adimlar: [
      DANISAN_SEC,
      { hedef: '[data-tur="olcum-ekle"]', metin: "Kilo, boy ve diğer ölçümleri girin; gelişim raporu bunlardan çıkar." },
      { hedef: '[data-tur="plan-disa-aktar"]', metin: "Planı PDF olarak indirin ya da danışana e-postayla gönderin." },
    ],
  },
};
